import { render, staticRenderFns } from "./HomeBalanceSummaryLoader.vue?vue&type=template&id=5701997a&scoped=true"
import script from "./HomeBalanceSummaryLoader.vue?vue&type=script&lang=ts"
export * from "./HomeBalanceSummaryLoader.vue?vue&type=script&lang=ts"
import style0 from "./HomeBalanceSummaryLoader.vue?vue&type=style&index=0&id=5701997a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5701997a",
  null
  
)

export default component.exports